import { AdminPendingBusinessesScreen } from '@/features/admin/screens/admin-pending-businesses-screen';

export default function PendingBusinessesPage() {
  return <AdminPendingBusinessesScreen />;
}
